import { errorMessages } from './const';
import * as regExpPatterns from './regexp-patterns';

export const getParamFromNL = (params, searchSelecting, enableNaturalLanguageSearch) => {
	const { adults, children } = searchSelecting || {};
	const hasNogParam = adults || children;

	return hasNogParam && enableNaturalLanguageSearch
		? {
				adults,
				children,
				...params,
			}
		: params;
};

export const fetchWithTimeout = async (fetchFn, timeLimit) => {
	let timeoutHandle;
	const timeoutPromise = new Promise((_resolve, reject) => {
		timeoutHandle = setTimeout(() => reject(new Error('NLSearch timeout limit reached')), timeLimit);
	});

	return Promise.race([fetchFn, timeoutPromise]).then((result) => {
		clearTimeout(timeoutHandle);
		return result;
	});
};

export const fetchNTL = (prompt, config) => {
	const { brand, endpoints } = config;

	return fetch(endpoints.nlsApi, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			prompt_text: prompt || '',
			brand_name: brand.code,
			next_gen: true,
		}),
	}).then((response) => {
		if (!response.ok) {
			throw new Error(`NLSearch error. Status: ${response.status}`);
		}
		return response.json();
	});
};

export const isValidInput = (input) => {
	let sanitizedInput = input;
	for (const regExp of Object.values(regExpPatterns)) {
		sanitizedInput = sanitizedInput.replace(regExp, '');
	}

	if (sanitizedInput !== input) {
		throw new Error(errorMessages.pii);
	}

	return true;
};
